import { atom } from "jotai";

// Shared across every slide's HeroScrollHint instance, so "shown once" is a single
// page-wide fact instead of N independent copies. The timers themselves are owned by
// a single useHeroScrollHintScheduler call in Hero - see use-hero-scroll-hint-scheduler.ts.
export const heroScrollHintVisibleState = atom(false);
export const heroScrollHintShownState = atom(false);
